// Dependencies
import React, { Component } from 'react';
import RegistrationFormStepTitleComponent from '../form-step-title/form-step-title';

// Primereact imports
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

// Multi lang
import { getLanguage, withTranslation } from 'react-multi-lang';

// Styling
import './step-3.scss';

// Redux
import { connect } from 'react-redux';
import { updateFormStep, updateStep3State } from '../../../redux/actions/form';

// Utils
import { getFormValue } from '../../../common/utils/form-utils';
import { EU_WITHOUT_PT_LIST, NON_EU_LIST } from '../../../common/lists/countries';
import { getCpeBallotList } from '../../../common/lists/ballot';
import { formatYesNoDropdownLists, getYesNoDropdownList } from '../../../common/utils/form-data-utils';
import { FORM_FIELD_ACSS_BALLOT, FORM_FIELD_ACSS_BALLOT_NUMBER, FORM_FIELD_BALLOT_COUNTRY, FORM_FIELD_BALLOT_COUNTRY_EUEFTA, FORM_FIELD_CPE_BALLOT, FORM_FIELD_CPE_BALLOT_ENTITY, FORM_FIELD_CPE_BALLOT_NUMBER, FORM_FIELD_CPE_ENTITY, FORM_FIELD_PREVIOUS_REGISTRATION, FORM_STEP_3_STATE, NO_OPTION, REGISTRATION_STATE_REVISION, STEP_STATE_SUBMITTED, STEP_STATE_VALIDATION_ERROR, YES_OPTION } from '../../../common/constants';

class RegistrationFormStep3Component extends Component {

    constructor(props) {
        super(props);
        this.state = {
            previousRegistration: { key: FORM_FIELD_PREVIOUS_REGISTRATION, value: formatYesNoDropdownLists(false, this.props.language) },
            acssBallot: { key: FORM_FIELD_ACSS_BALLOT, value: formatYesNoDropdownLists(false, this.props.language) },
            ballotCountryEuEfta: { key: FORM_FIELD_BALLOT_COUNTRY_EUEFTA, value: formatYesNoDropdownLists(false, this.props.language) },
            cpeBallot: { key: FORM_FIELD_CPE_BALLOT, value: formatYesNoDropdownLists(false, this.props.language) },
            acssBallotNumber: { key: FORM_FIELD_ACSS_BALLOT_NUMBER, value: "" },
            cpeBallotNumber: { key: FORM_FIELD_CPE_BALLOT_NUMBER, value: "" },
            ballotCountry: { key: FORM_FIELD_BALLOT_COUNTRY, value: null },
            cpeBallotEntity: { key: FORM_FIELD_CPE_BALLOT_ENTITY, value: "" },
            // Validation flags
            validAcssBallotNumber: true,
            validCpeEntityEu: true,
            validCpeEntityNonEu: true,
            validCpeBallotNumber: true,
            validBallotEuCountry: true,
            validBallotNonEuCountry: true
        }
    }

    componentDidMount() {
        this.setState({
            previousRegistration: formatYesNoDropdownLists(getFormValue(FORM_FIELD_PREVIOUS_REGISTRATION, this.props.formFields), this.props.language),
            acssBallot: formatYesNoDropdownLists(getFormValue(FORM_FIELD_ACSS_BALLOT, this.props.formFields), this.props.language),
            ballotCountryEuEfta: formatYesNoDropdownLists(getFormValue(FORM_FIELD_BALLOT_COUNTRY_EUEFTA, this.props.formFields), this.props.language),
            cpeBallot: formatYesNoDropdownLists(getFormValue(FORM_FIELD_CPE_BALLOT, this.props.formFields), this.props.language),
            acssBallotNumber: getFormValue(FORM_FIELD_ACSS_BALLOT_NUMBER, this.props.formFields),
            cpeBallotNumber: getFormValue(FORM_FIELD_CPE_BALLOT_NUMBER, this.props.formFields),
            ballotCountry: getFormValue(FORM_FIELD_BALLOT_COUNTRY, this.props.formFields),
            cpeBallotEntity: getFormValue(FORM_FIELD_CPE_BALLOT_ENTITY, this.props.formFields),
        });
    }

    updateFormComponent(column, value) {
        this.setState({
            [column]: { key: column, value: value }
        });
    }

    validateForm() {
        const validAcssBallotNumber = (this.state.previousRegistration.value.code === NO_OPTION.code && this.state.acssBallot.value.code === NO_OPTION.code) ||
                                  (this.state.previousRegistration.value.code === YES_OPTION.code && this.state.acssBallot.value.code === NO_OPTION.code) ||
                                  (this.state.previousRegistration.value.code === YES_OPTION.code && this.state.acssBallot.value.code === YES_OPTION.code && this.state.acssBallotNumber !== "");

        const validBallotEuCountry = (this.state.previousRegistration.value.code === NO_OPTION.code) ||
                                     (this.state.acssBallot.value.code === YES_OPTION.code) ||
                                     (this.state.ballotCountryEuEfta.value.code === NO_OPTION.code) ||
                                     (this.state.previousRegistration.value.code === YES_OPTION.code && 
                                            this.state.acssBallot.value.code === NO_OPTION.code &&
                                            this.state.ballotCountryEuEfta.value.code === YES_OPTION.code &&
                                            this.state.ballotCountry !== null
                                    );

        const validBallotNonEuCountry = (this.state.previousRegistration.value.code === NO_OPTION.code) ||
                                    (this.state.acssBallot.value.code === YES_OPTION.code) ||
                                    (this.state.ballotCountryEuEfta.value.code === YES_OPTION.code) ||
                                    (this.state.previousRegistration.value.code === YES_OPTION.code && 
                                            this.state.acssBallot.value.code === NO_OPTION.code &&
                                            this.state.ballotCountryEuEfta.value.code === NO_OPTION.code &&
                                            this.state.ballotCountry !== null
                                    );

        const validCpeEntityEu = (this.state.previousRegistration.value.code === NO_OPTION.code) ||
                               (this.state.acssBallot.value.code === YES_OPTION.code) ||
                               (this.state.ballotCountryEuEfta.value.code === NO_OPTION.code) ||
                               (this.state.cpeBallot.value.code === NO_OPTION.code) ||
                               (this.state.previousRegistration.value.code === YES_OPTION.code && 
                                    this.state.acssBallot.value.code === NO_OPTION.code && 
                                    this.state.ballotCountryEuEfta.value.code === YES_OPTION.code && 
                                    this.state.cpeBallot.value.code === YES_OPTION.code &&
                                    this.state.cpeBallotEntity !== "");

        const validCpeBallotNumber = (this.state.previousRegistration.value.code === NO_OPTION.code) ||
                                    (this.state.acssBallot.value.code === YES_OPTION.code) ||
                                    (this.state.ballotCountryEuEfta.value.code === NO_OPTION.code) ||
                                    (this.state.cpeBallot.value.code === NO_OPTION.code) ||
                                    (this.state.previousRegistration.value.code === YES_OPTION.code && 
                                         this.state.acssBallot.value.code === NO_OPTION.code && 
                                         this.state.ballotCountryEuEfta.value.code === YES_OPTION.code && 
                                         this.state.cpeBallot.value.code === YES_OPTION.code &&
                                         this.state.cpeBallotNumber !== "");

        const validCpeEntityNonEu = (this.state.previousRegistration.value.code === NO_OPTION.code) ||
                                (this.state.acssBallot.value.code === YES_OPTION.code) ||
                                (this.state.ballotCountryEuEfta.value.code === YES_OPTION.code) ||
                                (this.state.previousRegistration.value.code === YES_OPTION.code && 
                                    this.state.acssBallot.value.code === NO_OPTION.code && 
                                    this.state.ballotCountryEuEfta.value.code === NO_OPTION.code && 
                                    this.state.cpeBallotEntity !== "");

        this.setState({
            validAcssBallotNumber: validAcssBallotNumber,
            validCpeEntityEu: validCpeEntityEu,
            validCpeEntityNonEu: validCpeEntityNonEu,
            validCpeBallotNumber: validCpeBallotNumber,
            validBallotEuCountry: validBallotEuCountry,
            validBallotNonEuCountry: validBallotNonEuCountry
        });

        return validAcssBallotNumber && validCpeEntityEu && validCpeEntityNonEu && validCpeBallotNumber && validBallotEuCountry && validBallotNonEuCountry;
    }

    submitStep() {
        if(this.validateForm()) {
            this.props.updateStep3State(STEP_STATE_SUBMITTED);

            this.props.updateFormStep(1, 
                [
                    { key: FORM_FIELD_PREVIOUS_REGISTRATION, value: this.state.previousRegistration },
                    { key: FORM_FIELD_ACSS_BALLOT, value: this.state.acssBallot },
                    { key: FORM_FIELD_BALLOT_COUNTRY_EUEFTA, value: this.state.ballotCountryEuEfta },
                    { key: FORM_FIELD_CPE_BALLOT, value: this.state.cpeBallot },
                    { key: FORM_FIELD_ACSS_BALLOT_NUMBER, value: this.state.acssBallotNumber },
                    { key: FORM_FIELD_CPE_BALLOT_NUMBER, value: this.state.cpeBallotNumber },
                    { key: FORM_FIELD_BALLOT_COUNTRY, value: this.state.ballotCountry },
                    { key: FORM_FIELD_CPE_BALLOT_ENTITY, value: this.state.cpeBallotEntity },
                    { key: FORM_STEP_3_STATE, value: STEP_STATE_SUBMITTED }
                ],
                () => this.props.onNext());
        }
        else {
            this.props.updateStep3State(STEP_STATE_VALIDATION_ERROR);

            this.props.updateFormStep(1, 
                [
                    { key: FORM_STEP_3_STATE, value: STEP_STATE_VALIDATION_ERROR }
                ],
                () => {});
        }
    }

    render() {
        return (
            <>
                <div id="data-container" className="card p-fluid mgt-20">
                    <div className="grid">
                        <div className="col-12">
                            <div className="grid mgt-10">
                                <RegistrationFormStepTitleComponent title={this.props.t("registration-form.step-3.title")}
                                                                    subtitles={[]} />
                                <div className='col-12 t-align-left'>
                                    <label htmlFor="previousRegistration">{this.props.t("profile.areas.ballot.previous-registration")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="previousRegistration" value={this.state.previousRegistration.value} options={getYesNoDropdownList(getLanguage())} disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} optionLabel="name" onChange={(evt) => this.updateFormComponent("previousRegistration", evt.value)}></Dropdown>
                                </div>
                                {
                                    this.state.previousRegistration.value.code === YES_OPTION.code ? 
                                        <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                            <label htmlFor="acssBallot">{this.props.t("profile.areas.ballot.has-acss-ballot")} <span className="invalid-message">*</span></label>
                                            <Dropdown id="acssBallot" value={this.state.acssBallot.value} options={getYesNoDropdownList(getLanguage())} disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} optionLabel="name" onChange={(evt) => this.updateFormComponent("acssBallot", evt.value)}></Dropdown>
                                        </div>
                                    : null
                                }
                                {
                                    this.state.previousRegistration.value.code === YES_OPTION.code && this.state.acssBallot.value.code === YES_OPTION.code ? 
                                        <div className='col-1 t-align-right mgt-25'>
                                            <span>C-</span>
                                        </div>
                                        : null
                                }
                                {
                                    this.state.previousRegistration.value.code === YES_OPTION.code && this.state.acssBallot.value.code === YES_OPTION.code ? 
                                        <div className='col-11 md:col-11 lg:col-5 t-align-left'>
                                            <label htmlFor="acssNumber">{this.props.t("profile.areas.ballot.ballot-number")} <span className="invalid-message">*</span></label>
                                            <InputText id="acssNumber" value={this.state.acssBallotNumber.value} type="text" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} onChange={(evt) => this.updateFormComponent("acssBallotNumber", evt.target.value)} />
                                            { !this.state.validAcssBallotNumber ? <div className="col-12 lg:col-12"><small className="p-error">{this.props.t("general.mandatory-field")}</small></div> : null }
                                        </div>
                                        : null
                                }
                                {
                                    this.state.previousRegistration.value.code === YES_OPTION.code && this.state.acssBallot.value.code === NO_OPTION.code ? 
                                        <div className='col-12 t-align-left'>
                                            <label htmlFor="hasBallotEuEftaCountry">{this.props.t("profile.areas.ballot.has-eu-efta-ballot")} <span className="invalid-message">*</span></label>
                                            <Dropdown id="hasBallotEuEftaCountry" value={this.state.ballotCountryEuEfta.value} options={getYesNoDropdownList(getLanguage())} optionLabel="name" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} onChange={(evt) => this.updateFormComponent("ballotCountryEuEfta", evt.value)}></Dropdown>
                                        </div>
                                        : null
                                }
                                {
                                    this.state.previousRegistration.value.code === YES_OPTION.code && 
                                    this.state.acssBallot.value.code === NO_OPTION.code &&
                                    this.state.ballotCountryEuEfta.value.code === YES_OPTION.code ? 
                                        <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                            <label htmlFor="ballotEuCountry">{this.props.t("profile.areas.ballot.eu-efta-country")} <span className="invalid-message">*</span></label>
                                            <Dropdown id="ballotEuCountry" value={this.state.ballotCountry.value} disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} options={EU_WITHOUT_PT_LIST} optionLabel="name" onChange={(evt) => this.updateFormComponent("ballotCountry", evt.value)}></Dropdown>
                                            { !this.state.validBallotEuCountry ? <div className="col-12 lg:col-12"><small className="p-error">{this.props.t("general.mandatory-field")}</small></div> : null }
                                        </div>
                                        : null
                                }
                                {
                                    this.state.previousRegistration.value.code === YES_OPTION.code && 
                                    this.state.acssBallot.value.code === NO_OPTION.code &&
                                    this.state.ballotCountryEuEfta.value.code === YES_OPTION.code ? 
                                        <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                            <label htmlFor="hasCpeBallot">{this.props.t("profile.areas.ballot.has-cpe-ballot")} <span className="invalid-message">*</span></label>
                                            <Dropdown id="hasCpeBallot" value={this.state.cpeBallot.value} disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} options={getCpeBallotList(getLanguage())} optionLabel="name" onChange={(evt) => this.updateFormComponent("cpeBallot", evt.value)}></Dropdown>
                                        </div>
                                        : null
                                }
                                {
                                    this.state.previousRegistration.value.code === YES_OPTION.code && 
                                    this.state.acssBallot.value.code === NO_OPTION.code &&
                                    this.state.ballotCountryEuEfta.value.code === YES_OPTION.code && 
                                    this.state.cpeBallot.value.code === YES_OPTION.code ? 
                                        <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                            <label htmlFor="cpeEntity">{this.props.t("profile.areas.ballot.cpe-entity")} <span className="invalid-message">*</span></label>
                                            <InputText id="cpeEntity" value={this.state.cpeBallotEntity.value} disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} type="text" onChange={(evt) => this.updateFormComponent("cpeBallotEntity", evt.target.value)} />
                                            { !this.state.validCpeEntityEu ? <div className="col-12 lg:col-12"><small className="p-error">{this.props.t("general.mandatory-field")}</small></div> : null }
                                        </div>
                                        : null
                                }
                                {
                                    this.state.previousRegistration.value.code === YES_OPTION.code && 
                                    this.state.acssBallot.value.code === NO_OPTION.code &&
                                    this.state.ballotCountryEuEfta.value.code === YES_OPTION.code && 
                                    this.state.cpeBallot.value.code === YES_OPTION.code ? 
                                        <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                            <label htmlFor="processNumber">{this.props.t("profile.areas.ballot.process-num")} <span className="invalid-message">*</span></label>
                                            <InputText id="processNumber" value={this.state.cpeBallotNumber.value} disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} type="text" onChange={(evt) => this.updateFormComponent("cpeBallotNumber", evt.target.value)} />
                                            { !this.state.validCpeBallotNumber ? <div className="col-12 lg:col-12"><small className="p-error">{this.props.t("general.mandatory-field")}</small></div> : null }
                                        </div>
                                        : null
                                }
                                {
                                    this.state.previousRegistration.value.code === YES_OPTION.code && 
                                    this.state.acssBallot.value.code === NO_OPTION.code &&
                                    this.state.ballotCountryEuEfta.value.code === NO_OPTION.code ? 
                                        <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                            <label htmlFor="ballotCountry">{this.props.t("profile.areas.ballot.non-eu-efta-country")} <span className="invalid-message">*</span></label>
                                            <Dropdown id="ballotCountry" value={this.state.ballotCountry.value} disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} options={NON_EU_LIST} optionLabel="name" onChange={(evt) => this.updateFormComponent("ballotCountry", evt.value)}></Dropdown>
                                            { !this.state.validBallotNonEuCountry ? <div className="col-12 lg:col-12"><small className="p-error">{this.props.t("general.mandatory-field")}</small></div> : null }
                                        </div>
                                        : null
                                }
                                {
                                    this.state.previousRegistration.value.code === YES_OPTION.code && 
                                    this.state.acssBallot.value.code === NO_OPTION.code &&
                                    this.state.ballotCountryEuEfta.value.code === NO_OPTION.code ? 
                                        <div className='col-12 md:col-12 lg:col-6 t-align-left'>
                                            <label htmlFor="entity">{this.props.t("profile.areas.ballot.entity")} <span className="invalid-message">*</span></label>
                                            <InputText id="entity" value={this.state.cpeBallotEntity.value} type="text" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} onChange={(evt) => this.updateFormComponent("cpeBallotEntity", evt.target.value)} />
                                            { !this.state.validCpeEntityNonEu ? <div className="col-12 lg:col-12"><small className="p-error">{this.props.t("general.mandatory-field")}</small></div> : null }
                                        </div>
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION ?
                        <div className="mgt-20">
                            <div className="grid">
                                <div className="col-4 t-align-left mgt-10">
                                    <Button label={this.props.t("general.back")} severity="info" raised outlined onClick={(evt) => this.props.onBack()} />
                                </div> 
                                <div className="col-4 t-align-center mgt-10">
                                    <Button icon="pi pi-question-circle" severity='success' label="Verificar passo 3" raised />
                                </div> 
                                <div className="col-4 t-align-right mgt-10">
                                    <Button label={this.props.t("general.next")} severity="info" raised outlined onClick={(evt) => this.props.onNext()} />
                                </div> 
                            </div>
                        </div>
                        : null
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        registrationState: state.authentication.registrationState,
        formFields: state.form.formFields,
        language: state.profile.language
    } 
};
  
const mapDispatchToProps = (dispatch) => {
    return {
        updateFormStep: (stepFields) => { dispatch(updateFormStep(stepFields)) },
        updateStep3State: (state) => { dispatch(updateStep3State(state)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(RegistrationFormStep3Component));